import { CellSelection } from "@tiptap/pm/tables";

import type { Selection } from "@tiptap/pm/state";

export function isCellSelection(selection: Selection): selection is CellSelection {
  return selection instanceof CellSelection;
}
